import React from 'react'
import Header from '../../common/Header'
import CommonHeroSection from '../../common/CommonHeroSection'
import CommonBreadcrumb from '../../common/CommonBreadcrumb'
import DynamicTourSection from '../../sections/CommonSection/DynamicToureSection'
import Footer from '../../common/Footer'
import { ootyKodaikanalData } from './tourPackageData'

function OotyKodaikanal() {
    return (
        <>
            <Header />
            <CommonHeroSection title="Ooty Kodaikanal" />
            <CommonBreadcrumb items={["Ooty Kodaikanal"]} />
            <DynamicTourSection {...ootyKodaikanalData} />
            <Footer />
        </>
    )
}

export default OotyKodaikanal